import { Component } from '@angular/core';

import { footerNavigation } from '@Constants';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  footerNavigation = footerNavigation;
}
